<div class="section" id="quizzes">
    <div class="container cc-education">
        <div class="card" data-aos="fade-up" data-aos-offset="18">
              
            <div class="card-body">

<h4>Quizzes</h4>
    
    <h5>Personality Quizzes</h5>
    <p>Please take the following quizzes and be sure to screenshot your final results. Do not purchase anything.</p>
    
    <ul>
        <li>
            <strong>16 Personalities Quiz:</strong>
            <a href="https://www.16personalities.com/free-personality-test" target="_blank">Take the test</a>
        </li>
        <li>
            <strong>Similar Minds Quiz (All in one long version - 3rd one down):</strong>
            <a href="https://similarminds.com/" target="_blank">Take the test</a>
        </li>
        <li>
            <strong>5 Love Languages Quiz:</strong>
            <a href="https://5lovelanguages.com/start/" target="_blank">Take the test</a>
        </li>
    </ul>
    
    <h5>Mental Health Quizzes</h5>
    <p>Take the following quizzes and screenshot your final results.</p>
    
    <ul>
        <li>
            <strong>Anxiety Quiz:</strong>
            <a href="https://screening.mhanational.org/screening-tools/anxiety/" target="_blank">Take the test</a>
        </li>
        <li>
            <strong>Depression Quiz:</strong>
            <a href="https://screening.mhanational.org/screening-tools/depression/?ref=https://www.google.com/" target="_blank">Take the test</a>
        </li>
        <li>
            <strong>Choose another mental health quiz:</strong>
            <a href="https://screening.mhanational.org/screening-tools/?ref=https://www.google.com/" target="_blank">Explore tests</a>
        </li>
    </ul>
    
    <h5>Additional Resources</h5>
    <ul>
        <li>
            <strong>Sign up for ADDitude Newsletter:</strong>
            <a href="https://www.additudemag.com/adhd-newsletters/" target="_blank">Subscribe</a>
        </li>
        <li>
            <strong>ADHD Webinars and Podcasts:</strong>
            <a href="https://www.additudemag.com/adhd-expert-webinars-index/" target="_blank">Explore resources</a>
        </li>
    </ul>
    
    <h5>Mental Health Support</h5>
    <p>If you are in crisis, please reach out to support services:</p>
    <ul>
        <li><strong>National Suicide Prevention Lifeline:</strong> Dial <strong>988</strong></li>
        <li><strong>Crisis Text Line:</strong> Text <strong>TALK</strong> to <strong>741741</strong></li>
    </ul>

    </div>
    </div>
    </div>
</div>